import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { stopPropagation } from '../../../utils/events'
import { Avatar, AVATAR_HEIGHT_24 } from '../../Avatar'
import Button from '../../Button'
import { FloatingTooltip } from '../../Floating'
import { ICON_COLOR } from '../../Icon'
import { Status, STATUS_SIZE_16 } from '../../Status'
import { TableCellBase, TableCellText } from '../../Table'

import {
  APPLICANT_NEW_BADGE_TEXT_COLOR,
  QA_NAME_APPLICANT_IDENTITY_NAME,
  QA_NAME_APPLICANT_IDENTITY_NEW_BADGE,
} from './RentalPortalApplicantIdentityCell.constants'
import {
  getIsRentalPortalApplicantIdentityMasked,
  getIsRentalPortalApplicantNew,
  getRentalPortalApplicantIdentityLabel,
  getRentalPortalApplicantIdentityName,
} from './RentalPortalApplicantIdentityCell.utils'

import * as styles from './RentalPortalApplicantIdentityCell.module.css'

import LockIcon from '../../../icons/lock.svg'

function RentalPortalApplicantIdentityCell({
  applicant,
  onClickName,
  ...cellProps
}) {
  const { t } = useTranslation()

  function handleClickName(event) {
    stopPropagation(event)

    onClickName()
  }

  const isMasked = getIsRentalPortalApplicantIdentityMasked(applicant)
  const maskedNotice = isMasked
    ? t('RentalPortal.ApplicantIdentityMaskedTooltipKey')
    : null

  return (
    <TableCellBase {...cellProps}>
      <span className={styles.content}>
        <FloatingTooltip
          content={maskedNotice}
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          <Avatar
            Icon={isMasked ? LockIcon : null}
            className={styles.avatar}
            color={applicant?.avatar_color}
            iconProps={{ color: ICON_COLOR.SecondaryTextColor }}
            size={AVATAR_HEIGHT_24}
            text={getRentalPortalApplicantIdentityName(applicant)}
          />
        </FloatingTooltip>
        {onClickName ? (
          <Button.Text
            className={styles.nameButton}
            qaName={QA_NAME_APPLICANT_IDENTITY_NAME}
            text={getRentalPortalApplicantIdentityLabel({ applicant, t })}
            textClassName={styles.nameButtonText}
            onClick={handleClickName}
          />
        ) : (
          <TableCellText
            showTooltip={false}
            value={getRentalPortalApplicantIdentityLabel({ applicant, t })}
          />
        )}
        {getIsRentalPortalApplicantNew(applicant) ? (
          <Status
            className={styles.newBadge}
            height={STATUS_SIZE_16}
            qaName={QA_NAME_APPLICANT_IDENTITY_NEW_BADGE}
            text={t('RentalPortal.ApplicantBadgeNewKey')}
            textColor={APPLICANT_NEW_BADGE_TEXT_COLOR}
          />
        ) : null}
      </span>
    </TableCellBase>
  )
}

export default RentalPortalApplicantIdentityCell
